/**
 * @file: usePreInspectionUserPicker.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useOrgMemberPicker } from '@euler/app/flows/task/functions';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { OrgMember } from '@euler/model/entity';
import { useCallback, useState } from 'react';

export const usePreInspectionUserPicker = () => {
  const { profile } = useTaskContext();

  const [user, setUser] = useState<{ id: number; name: string }>({
    id: profile.user.memberId,
    name: profile.user.name,
  });

  const onChange = useCallback((tech: OrgMember) => {
    setUser({ id: tech.id, name: tech.name });
  }, []);

  const pickerInfo = useOrgMemberPicker({ currentMemberId: user.id, onChange });

  return {
    ...pickerInfo,
    user,
  };
};
